import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { ServiceIdentityBaseSchema } from './base';
export const CreatedServiceAccountIdentityResponseSchema = ServiceIdentityBaseSchema.extend({
    prefix: z.string(),
    webServiceToken: z.string(),
});
export class CreatedServiceAccountIdentityResponseDto extends createZodDto(CreatedServiceAccountIdentityResponseSchema) {
}
